import { TikTokIcon as TikTokIconBase } from 'components/icons'

export interface IconProps {
  className?: string
  svgClassName?: string
  height?: number
  width?: number
}

export const TikTokIcon = ({
  className = '',
  svgClassName = '',
  height = 24,
  width = 24,
}: IconProps) => (
  <TikTokIconBase
    className={className}
    height={height}
    svgClassName={svgClassName}
    width={width}
  />
)

export const InstagramIcon = ({
  className = '',
  svgClassName = '',
  height = 24,
  width = 24,
}: IconProps) => (
  <span aria-label="Instagram Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height + 1}
      viewBox={`0 0 ${width + 1} ${height + 1}`}
      width={width + 1}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_851_7701)">
        <path
          clipRule="evenodd"
          d="M7.54986 0.728149H17.6967C21.5071 0.728149 24.623 3.80555 24.623 7.56504V17.6844C24.623 21.4448 21.5071 24.5213 17.6967 24.5213H7.54986C3.73945 24.5213 0.623047 21.4448 0.623047 17.6844V7.56504C0.623047 3.80555 3.73941 0.728149 7.54986 0.728149ZM12.5584 6.20086C16.2612 6.20086 19.2659 9.20562 19.2659 12.9084C19.2659 16.6116 16.2612 19.616 12.5584 19.616C8.85471 19.616 5.8504 16.6116 5.8504 12.9084C5.8504 9.20562 8.85471 6.20086 12.5584 6.20086ZM12.5584 8.46639C15.0104 8.46639 17.0004 10.456 17.0004 12.9084C17.0004 15.3608 15.0104 17.3509 12.5584 17.3509C10.1055 17.3509 8.11592 15.3609 8.11592 12.9084C8.11592 10.456 10.1055 8.46639 12.5584 8.46639ZM19.0476 5.2712C19.6491 5.2712 20.1367 5.75885 20.1367 6.3599C20.1367 6.9614 19.6491 7.44905 19.0476 7.44905C18.4465 7.44905 17.9589 6.9614 17.9589 6.3599C17.9589 5.75885 18.4465 5.2712 19.0476 5.2712ZM8.37898 2.6717H16.8684C20.0561 2.6717 22.6631 5.26587 22.6631 8.4359V16.9678C22.6631 20.1378 20.0561 22.7315 16.8684 22.7315H8.37898C5.1913 22.7315 2.58385 20.1378 2.58385 16.9678V8.43582C2.58385 5.26587 5.1913 2.6717 8.37898 2.6717Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_851_7701">
          <rect
            fill="currentColor"
            height={height}
            transform="translate(0.623047 0.625)"
            width={width}
          />
        </clipPath>
      </defs>
    </svg>
  </span>
)

export const YouTubeIcon = ({
  className = '',
  svgClassName = '',
  height = 24,
  width = 24,
}: IconProps) => (
  <span aria-label="YouTube Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_851_7718)">
        <path
          clipRule="evenodd"
          d="M24.1344 7.82644C24.1344 7.82644 23.9001 6.17213 23.179 5.44575C22.2653 4.49036 21.2421 4.48418 20.7744 4.42883C17.4184 4.18433 12.378 4.18433 12.378 4.18433H12.3692C12.3692 4.18433 7.33096 4.18433 3.97317 4.42883C3.50367 4.48594 2.48187 4.48995 1.56856 5.44575C0.847056 6.17213 0.617631 7.82644 0.617631 7.82644C0.617631 7.82644 0.378906 9.76774 0.378906 11.7131V13.5321C0.378906 15.4734 0.617631 17.4188 0.617631 17.4188C0.617631 17.4188 0.851931 19.073 1.56856 19.8008C2.48187 20.7561 3.68217 20.7251 4.21812 20.827C6.13951 21.0104 12.3798 21.0657 12.3798 21.0657C12.3798 21.0657 17.4246 21.0569 20.7806 20.8168C21.2501 20.7614 22.2714 20.7557 23.1852 19.7999C23.9067 19.0735 24.1406 17.4174 24.1406 17.4174C24.1406 17.4174 24.3794 15.4761 24.3794 13.5308V11.7117C24.3745 9.7704 24.1357 7.82513 24.1357 7.82513L24.1344 7.82644ZM9.89191 15.7392V8.994L16.3754 12.3779L9.89191 15.7392Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_851_7718">
          <rect
            fill="white"
            height={height}
            transform="translate(0.378906 0.625)"
            width={width}
          />
        </clipPath>
      </defs>
    </svg>
  </span>
)

export const FacebookIcon = ({
  className = '',
  svgClassName = '',
  height = 24,
  width = 24,
}: IconProps) => (
  <span aria-label="Facebook Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M5.37891 0.625C2.61748 0.625 0.378906 2.86358 0.378906 5.625V19.625C0.378906 22.3864 2.61748 24.625 5.37891 24.625H19.3789C22.1403 24.625 24.3789 22.3864 24.3789 19.625V5.625C24.3789 2.86358 22.1403 0.625 19.3789 0.625H5.37891ZM17.6501 12.6232L17.1209 16.0784H14.3271V24.5551H10.5995V16.0784H7.56445V12.6232H10.5995V9.98892C10.5995 6.99281 12.3913 5.33911 15.115 5.33911C16.0112 5.35159 16.9053 5.42962 17.7901 5.57257V8.51421H16.2726C14.7901 8.51421 14.3271 9.43444 14.3271 10.38V12.6232H17.6501Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  </span>
)

export const LinkArrowIcon = ({
  className = '',
  svgClassName = '',
  height = 24,
  width = 24,
}: IconProps) => (
  <span aria-label="Link Arrow Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.5075 6.37759C11.0919 6.01391 11.0498 5.38215 11.4134 4.96651C11.7771 4.55087 12.4089 4.50875 12.8245 4.87244L20.819 11.8676C21.0315 12.051 21.166 12.3223 21.166 12.625C21.166 12.8773 21.0707 13.1189 20.9015 13.3026C20.8773 13.3288 20.8516 13.3539 20.8245 13.3776C20.8237 13.3783 20.823 13.379 20.8222 13.3796L12.8245 20.3776C12.4089 20.7413 11.7771 20.6992 11.4134 20.2835C11.0498 19.8679 11.0919 19.2361 11.5075 18.8724L17.5046 13.625H3.16602C2.61373 13.625 2.16602 13.1773 2.16602 12.625C2.16602 12.0727 2.61373 11.625 3.16602 11.625H17.5046L11.5075 6.37759Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  </span>
)
